import React, { FC, useEffect, useState } from 'react';
import { QmUserWithRoleType } from '@app/interfaces/qm-users.type';
import RubberTable from '@app/components/rubber-table';
import { TableColumn } from '@app/components/rubber-table/table.types';
import { Empty, Input, Toggle } from '@ui';
import {
  useAddOperatorToCommandMutation,
  useRemoveOperatorFromCommandMutation,
} from '@app/store/api/qm-module/qm-manage/qm-manage-commands.api';
import { QmCommandsOperatorsList } from '@app/interfaces/qm-module/qm-manage/qm-commands.type';
import useTranslation from '@app/hooks/use-translation';
import { toast } from 'react-toastify';
type CommandOperatorsFormPropsType = {
  operators: QmUserWithRoleType[];
  currentOperators?: QmCommandsOperatorsList;
  filter: string | undefined;
  setFilter: React.Dispatch<React.SetStateAction<string | undefined>>;
};
const CommandOperatorsForm: FC<CommandOperatorsFormPropsType> = (props) => {
  const { operators, currentOperators, filter, setFilter } = props;
  const { t } = useTranslation('pages.qmManage.commands.operators_modal');
  const [, trigger] = useState(0);
  useEffect(() => {
    trigger(1);
  }, []);

  // api
  const [addOperatorToTeam] = useAddOperatorToCommandMutation();
  const [removeOperatorFromTeam] = useRemoveOperatorFromCommandMutation();
  // api

  function handleMutateUserFromGroup(
    status: 'DELETE' | 'ADD',
    { user_id, item_id }: { user_id: string; item_id: string },
  ) {
    const team_id = currentOperators?.team_id || '';
    status === 'ADD'
      ? addOperatorToTeam({ user_id, team_id })
          .unwrap()
          .catch((err) => {
            if (err.status !== 403) return;
            toast.error(t('maybeOperatorInOtherTeam'));
          })
      : removeOperatorFromTeam({ team_id, item_id });
  }

  const tableColumns: TableColumn[] = [
    { index: 'username', title: t('username') },
    { index: 'status', title: t('status'), maxWidth: 150 },
  ];

  const tableData = operators.map((operator) => ({
    username: operator.username,
    status: (
      <div className="max-w-[80px]">
        <Toggle
          withoutStateChange
          onChecked={(value) => {
            const key: 'DELETE' | 'ADD' = value ? 'ADD' : 'DELETE';
            const user_id = operator.id;
            const item_id =
              currentOperators?.operators?.find((i) => i.user_id === user_id)?.item_id || '';
            handleMutateUserFromGroup(key, { user_id, item_id });
          }}
          checked={currentOperators?.operators?.map(({ user_id }) => user_id).includes(operator.id)}
        />
      </div>
    ),
  }));
  return (
    <div className="h-full flex flex-col py-[40px]">
      <div className="w-[300px] py-4">
        <Input
          defaultValue={filter}
          icon="SearchIcon"
          onChange={(event) => {
            const value = event.target.value;

            setFilter(value);
          }}
        />
      </div>
      <div className="bg-basic_app_bg h-full w-full p-4 rounded-defaultR ">
        {tableData.length ? (
          <RubberTable dataSource={tableData || []} columns={tableColumns} />
        ) : (
          <Empty />
        )}
      </div>
    </div>
  );
};

export default CommandOperatorsForm;
